/*
 * @Descripttion:
 * @FilePath: /mall-wap-vue/src/utils/authority.js
 * @Author: 张兴业
 * @Date: 2020-09-24 11:19:06
 * @LastEditors: hl
 * @LastEditTime: 2026-06-17 10:53:40
 */
import jwtDecode from "jwt-decode";
import { Toast } from "vant";
import store from "@/store";

export function setToken(data) {
  if (data && data.access_token) {
    localStorage.setItem("mall-wap-vue-token", data.access_token);
    store.dispatch("mine/getUserInfo").catch(err => {
      console.error("Failed to getUserInfo after setToken:", err);
    });
  }
}

export function getToken() {
  return localStorage.getItem("mall-wap-vue-token");
}

export function removeToken() {
  resetCachedRole();
  return localStorage.removeItem("mall-wap-vue-token");
}

const CACHED_ROLE_KEY = "CACHED_USER_ROLE";

/**
 * 缓存并更新用户身份角色
 * @param {Array|string} roles 角色对象数组，或具体角色字符串
 */
export function setCurrentRole(roles) {
  let newRole = "Guest";
  if (Array.isArray(roles)) {
    const checkIsStore = roles.some(role => role.id === 10002);
    const hasRoleRegistered = roles.some(role => role.id === 10003);
    if (checkIsStore) {
      newRole = "Store";
    } else if (hasRoleRegistered) {
      newRole = "Customer";
    }
  } else if (typeof roles === "string") {
    newRole = roles;
  }
  localStorage.setItem(CACHED_ROLE_KEY, newRole);
  return newRole;
}

/**
 * 获取当前持久化的用户角色
 */
export function getCurrentRole() {
  return localStorage.getItem(CACHED_ROLE_KEY) || "Guest";
}

/**
 * 重置当前用户角色为游客
 */
export function resetCachedRole() {
  localStorage.setItem(CACHED_ROLE_KEY, "Guest");
}

const guestWhiteList = [
  "/api/front/store/findStoreByCondition",
  "/api/front/product/retailHomepage/retailHomepage",
  "/api/front/retailSpu/findClientRetailSpuByParam",
  "/api/front/product/retailReceptionCategory/queryCategories",
  "/api/front/order/cart/getCartList",
  "/api/front/user/getGuestToken",
  "/api/front/product/retailSpu/mallretailspu",
  "/api/front/product/retailStoreTheme/queryRetailStoreThemeDetail",
  "/api/front/retailSpu/searchFoundList",
  "/api/product/activitySubCardUser/getUserActivitySubCards",
  "/api/front/store/switchStoreShare",
  "/api/front/product/retailHomepage/retailMiniHomepage",
  "/api/front/user/getUserInfo",
  "/api/front/notice/loadNoticee",
  "/api/daemon/wxmini/getPageAd",
  "/api/front/product/retailHomepage/retailHomepageDetailMaterial"
];

/**
 * 判断 token 是否即将过期 (余下有效时间 <= 12 小时)
 * @param {string|Object} token - JWT 令牌字符串或已解码的 Payload 对象
 * @returns {boolean}
 */
export function isExpiresed(token) {
  if (!token) return true;
  try {
    // 兼容 JWT 原始字符串与已解码的 Payload 对象，避免重复解码
    const decoded = typeof token === "string" ? jwtDecode(token) : token;
    if (decoded && decoded.exp) {
      const currentTimestamp = Math.floor(Date.now() / 1000);
      return decoded.exp - currentTimestamp <= 12 * 3600;
    }
  } catch (e) {
    return true;
  }
  return false;
}

/**
 * 判断用户登录状态，支持游客 Token API 白名单阻断
 * @param {string} url - 访问的 API 路径
 * @returns {boolean}
 */
export function isLogin(url = "") {
  const token = getToken();
  if (token) {
    try {
      // 提前执行一次解码，并将 decoded 传递给 isExpiresed 及后续角色判断复用
      const decodeToken = jwtDecode(token);
      if (isExpiresed(decodeToken)) {
        return false;
      }

      if (decodeToken.role && Array.isArray(decodeToken.role)) {
        if (decodeToken.role.indexOf("Registered") > -1) {
          // 正常注册用户，直接通过
          return true;
        } else {
          // 游客身份只能访问白名单接口
          const jg = guestWhiteList.some(item => url.indexOf(item) > -1);
          if (!jg) {
            url &&
              setTimeout(() => {
                Toast({
                  message: "游客不可访问，需登录。",
                  position: "bottom"
                });
              }, 100);
          }
          return jg;
        }
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
}
